import { isNullable } from '@app/utils'
import { stringCompareAlphabet } from '@app/utils/string'
import { getDateDiff, isValidDate } from '@app/utils/date'
import { isNumber } from '@app/typeGuards'

import { dateFormat } from '@app/constants'

// TODO обязательно покрыть тестами
export const sorterDispatcher = <DataType = unknown>(left: DataType, right: DataType): number => {
  if (isNullable(left) && isNullable(right)) return 0

  if (isNullable(right)) {
    return 1
  }

  if (isNullable(left)) {
    return -1
  }

  // TODO подумать как упростить работу с датой чтобы не делать два условия
  // Сортировка для дат c форматом DD_MM_YYYY
  if (
    typeof left === 'string' &&
    typeof right === 'string' &&
    isValidDate(left, dateFormat.DD_MM_YYYY) &&
    isValidDate(right, dateFormat.DD_MM_YYYY)
  ) {
    return getDateDiff(left, right, dateFormat.DD_MM_YYYY)
  }

  // Сортировка для дат c форматом DD_MM_YYYY_HH_mm
  if (
    typeof left === 'string' &&
    typeof right === 'string' &&
    isValidDate(left, dateFormat.DD_MM_YYYY_HH_mm) &&
    isValidDate(right, dateFormat.DD_MM_YYYY_HH_mm)
  ) {
    return getDateDiff(left, right, dateFormat.DD_MM_YYYY_HH_mm)
  }

  // Сортировка для чисел
  if (isNumber(left) && isNumber(right)) {
    return left - right
  }

  // Сортировка для строк
  if (typeof left === 'string' && typeof right === 'string') {
    return stringCompareAlphabet(left, right)
  }

  // Сортировка для буль
  if (typeof left === 'boolean' && typeof right === 'boolean') {
    return Number(left) - Number(right)
  }

  return 0
}
